const getters = {
  getPolicy: (state) => state.policy,
  getPolicies: (state) => state.policies,
  getPoliciesMeta: (state) => state.policiesMeta,
  getPartners: (state) => state.partners,
  getProductCategories: (state) => state.productCategories,
};

export default getters;
